// extracted by mini-css-extract-plugin
module.exports = {"form-button":"styles_form-button__2Xp58","form-forgot-password":"styles_form-forgot-password__3daAp","form-label":"styles_form-label__3kuBr"};